<template>
	<pop-up-wrapper @close="this.$emit('close')">
		<div class="pop-up-qcm-soluce">
			<img
				class="close"
				@click="this.$emit('close')"
				src="/img/close.svg"
				alt=""
			/>
			<p v-if="!isLoading && qcm.title" class="title">{{ qcm.title }}</p>
			<div class="btn-container">
				<button class="submit dark" @click="download">Télécharger</button>
			</div>
			<table v-if="!isLoading">
				<thead>
					<tr>
						<th>Questions</th>
						<th>Reponses</th>
					</tr>
				</thead>
				<tbody id="table">
					<tr v-for="question in questions" :key="question.id">
						<td v-html="question.question" v-mathjax></td>
						<td>
							<ul style="flex-direction: column;">
								<li v-for="answer in question.answers" :key="answer.id">
									<input type="checkbox" :checked="answer.is_correct"/> <span v-html="answer.answer" v-mathjax></span>
								</li>
							</ul>
						</td>
						
					</tr>
				</tbody>	
			</table>
			<Loader v-if="isLoading" />
		</div>
		<Loader v-if="isLoadingPdfGeneration" />

		<Teleport to="body">
			<PopUpShareResource v-if="isPopUpShareVisible" @close="isPopUpShareVisible = false" :id="id" :type="'corrected_qcm_id'"/>
		</Teleport>
	</pop-up-wrapper>
</template>

<script>
import { getQCMQuestionService } from '../../../services/qcmQuestionsServices'
import { getQCMService } from '../../../services/qcmServices'
import Loader from '../../Loader.vue'
import PopUpWrapper from '../PopUpWrapper.vue'
import { generatedQCMPDF } from '../../../utils/utils.js'

import PopUpShareResource from '../PopUpShareResource.vue'
export default {
	components: { PopUpWrapper,Loader,PopUpShareResource },
	emits: ['close'],
	props: {
		id: {
			type:Number,
			required: false
		},
		heritedQuestions: {
			type: Array,
			required: false
		}
	},
	data(){
		return {
			qcm: {},
			questions: [],
			isLoading: false,
			isLoadingPdfGeneration: false,
			isPopUpShareVisible: false
		}
	},

	methods: {
		async download(){
			this.isLoadingPdfGeneration = true
			try { await generatedQCMPDF(this.qcm, true) } 
			catch {
				this.$store.state.toast = {
					text: "Erreur lors de l'impression de la correction",
					status: 'error'
				}
			} finally { this.isLoadingPdfGeneration = false }
		},
		async getQcm(){
			this.isLoading = true
			const res = await getQCMService(this.id)
			this.qcm = res
			for(const question of this.qcm.questions){
				const res = await getQCMQuestionService(question.id)
				this.questions.push(res)
			}
			this.isLoading = false
			this.$nextTick(() => {
				this.reRender();
			});
		},
		async reRender() {
			if (window.MathJax.typesetPromise) {
				window.MathJax.typesetPromise();
			}
		}
		
	},
	created(){
		if(this.heritedQuestions){
			this.questions = this.heritedQuestions
		}
		else{
			this.getQcm()
		}
	}
	

}
</script>

<style>
</style>
